// extracted by mini-css-extract-plugin
export default {"container":"AdminLayout_container__14J17","analytics":"AdminLayout_analytics__4cXcL","duration":"AdminLayout_duration__u+9Uc"};